module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_8004.58e3b299.png";